import storage from '/src/utils/storage';

const storageLocal = storage('local');
const storageSession = storage('session');

export function clearAuthStorage() {
    storageLocal.remove('token');
    storageLocal.remove('refresh_token');
    storageLocal.remove('user');
    storageSession.remove('company');
    storageSession.remove('permissions');
    storageSession.remove('user');
}

export function normalizeAuthResponse(response = {}) {
    return {
        token: response?.token ?? response?.access_token ?? response?.accessToken ?? null,
        refreshToken: response?.refresh_token ?? response?.refreshToken ?? null,
        user: response?.user ?? response?.userData ?? null,
        company: response?.company ?? null,
        permissions: response?.permissions ?? [],
    };
}

export function persistAuthState({ token, refreshToken, user, company, permissions }) {
    if (token) {
        storageLocal.set('token', token);
    }

    if (refreshToken) {
        storageLocal.set('refresh_token', refreshToken);
    }

    if (user) {
        storageLocal.set('user', user);
    }

    if (company) {
        storageSession.set('company', company);
    }

    if (permissions) {
        storageSession.set('permissions', permissions);
    }
}
